import { plainToClass } from "class-transformer";
import { GetDateFromString } from "../../../../shared/scripts/date-functions";
import { PadNumber } from "../../../../shared/scripts/number-functions";

export class SiteInfo {
    StudyId: number;
    SiteId: number;
    SiteName: string;
    PI: string = "";
    Randomized: number;
    SiteActivated: number;
    ActivationDate: string;
    ActivationTimestamp: number;

    getSiteNameNumber(): string {
        return this.SiteName + " (" + PadNumber(this.SiteId + "", 3) + ")";
    }

    getSiteNumberFormatted(): string {
        return PadNumber(this.SiteId + "", 3);
    }

    setActivationTimestamp(dayOfMonth: string = "first"): void {
        if (this.ActivationDate != undefined) {
            let date: Date = GetDateFromString(this.ActivationDate, "hyphens-year-month-day-time");

            if (dayOfMonth == "first") { date.setDate(1); }

            this.ActivationTimestamp = date.getTime();
        }
    }

    static Parse(infoJson: any): SiteInfo[] {
        var parsed = plainToClass(SiteInfo, <SiteInfo[]>infoJson);

        return parsed;
    }

    static CreateNameMap(infoJson: any = undefined, info: SiteInfo[] = undefined): Map<number, string> {

        if (infoJson != undefined) {
            info = plainToClass(SiteInfo, <SiteInfo[]>infoJson);
        }
        let dictionary: Map<number, string> = new Map<number, string>();
        info.map((entry: SiteInfo) => {
            dictionary.set(entry.SiteId, entry.SiteName);
            //dictionary.set(entry.SiteNumber, entry.getSiteNameNumber());
        });
        return dictionary;
    }

    static FormatSiteNumber(siteNumber: number): string {
        return PadNumber(siteNumber + "", 3);
    }
}